import React, { useState } from "react";
import { Card, Button, Row, Col, Form, DatePicker, message } from "antd";
import dayjs from "dayjs";
import fileDownload from "js-file-download";
import axios from "../../../helpers/Axios";

const { RangePicker } = DatePicker;
const dateFormat = "MM/DD/YYYY";

const filingHeaders = {
    headers: {
      'X-Gravitee-Api-Key': process.env.REACT_APP_GRAVITEE_API_KEY_FILING,
    },
  };

const IndexReportCard = () => {
    const [dateRange, setDateRange] = useState([null, null]);
    const [loadingReport, setLoadingReport] = useState(false);
    const [form] = Form.useForm();

    const disabledDate = (current) => current && current > dayjs().endOf("day");

    const handleDateChange = (dates) => setDateRange(dates);

    const handleGenerateReport = async () => {
        const [startDate, endDate] = dateRange;

        if (!startDate || !endDate) {
            return message.warning("Please select a valid date range.");
        }

        setLoadingReport(true);

        try {
            const response = await axios.get(
                `https://api.fortisph.space/gateway/filing/reports/index/?start=${startDate.format("YYYY-MM-DD")}&end=${endDate.format("YYYY-MM-DD")}`,
                { responseType: "blob",
                    ...filingHeaders.headers
                }
            );
            fileDownload(
                response.data,
                `Index_Report_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`
            );
            message.success("Index report generated successfully!");
            form.resetFields();
            setDateRange([null, null]);
        } catch (err) {
            console.error(err);
            message.error("Failed to generate index report.");
        } finally {
            setLoadingReport(false);
        }
    };

    return (
        <Card title="Generate Index Report">
            <Form layout="horizontal" form={form} onFinish={handleGenerateReport}>
                <Row gutter={16}>
                    <Col xs={24} sm={24} md={16} lg={16}>
                        <Form.Item
                            name="date_range"
                            label="Date Range"
                            rules={[{ required: true, message: "Please select date range" }]}
                        >
                            <RangePicker
                                style={{ width: "100%" }}
                                onChange={handleDateChange}
                                disabledDate={disabledDate}
                                format={dateFormat}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={16} lg={16}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={loadingReport}>
                                Generate Report
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
};

export default IndexReportCard;
